<template>
  <div :class="fixed ? 'fixed-labels' : 'reports-table__column'">

    <header>
      <strong v-if="fixed">{{dataPoints.title}}</strong>
      <label dark :title="dataPoints.colname" v-else>
        {{dataPoints.colname}}
      </label>
    </header>

    <div class="reports-table__cell" v-if="!fixed">
      <p>{{dataPoints.total | tableNullFormat}}</p>
    </div>

    <section v-for="(item, index) in dataPoints.data" :key="index">
      <header v-if="fixed">
        <p>
          <span class="text">{{item.category}}</span>
          <span class="tooltip-text">{{item.category}}</span>
        </p>
      </header>

      <div v-else class="reports-table__cell">
        <p>
          {{item.total | tableNullFormat}}
        </p>
      </div>

      <div class="reports-table__cell"
           v-for="value in item.subCategories" :key="value">
        <p>{{ value }}</p>
      </div>

      <div class="reports-table__cell"
           v-if="item.subCategories"/>

      <!-- Last row for Totals -->
      <div class="reports-table__cell dark"
           v-if="index == dataPoints.data.length - 1">
        <p v-if="fixed">Total</p>
        <p v-else>{{columnTotal | tableNullFormat}}</p>
      </div>

    </section>

  </div>
</template>

<script>
  export default {
    name: "pogs-reports__table__column",
    props:['dataPoints', 'fixed'],
    computed: {
      columnTotal() {
        return this.dataPoints.data.reduce((acc,v) => {
          if (typeof v.total === "number") {
            return acc + v.total
          } else if (v.total !== undefined) { // Assume its a string
            if (typeof acc === "number")
              return acc + parseFloat(v.total.slice(0,-1)) + "%";
            else
              return parseFloat(acc.slice(0,-1)) + parseFloat(v.total.slice(0,-1)) + "%";
          } else {
            return acc
          }
        },0)
      }
    }
  }
</script>
